import type { SVGProps } from "react";
import * as React from "react";

export const PointerVerticalIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 10 20"
    className="fill-current"
    {...props}
  >
    <path
      fill="currentColor"
      d="M1.414 11.414a2 2 0 0 1 0-2.828L10 0v20z"
    />
  </svg>
);
